import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';

type DialogCloseButtonProps = {
  handleClose: () => void;
};

export const DialogCloseButton = (props: DialogCloseButtonProps) => {
  const { handleClose } = props;
  const { t } = useTranslation(['common']);
  return (
    <IconButton
      aria-label={t('common:statusMessages.closeDialog')}
      onClick={() => handleClose()}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        zIndex: 5000,
        color: (theme) => theme.palette.grey[500],
      }}
      size='medium'
    >
      <CloseIcon aria-hidden />
    </IconButton>
  );
};
